import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const FrozenIndex: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width ?? 24} height={height ?? 24} viewBox="0 0 180 180">
            <path
                fill={color}
                d="M112,67.3c42-.8,42-63.2,0-63.9-42,.8-42,63.2,0,63.9ZM112,12.2c30.4.5,30.4,45.7,0,46.3-30.4-.5-30.4-45.7,0-46.3Z"
            />
            <path
                fill={color}
                d="M169.5,119c-8.2-18.6-4.4-17.9-18.2-32.4-21.6-20.7-75.1-18.1-87.7,13.9-25.5,30.3-72.1-8.3-47.9-40.6,11.7-15.8,34-17.2,48.2-4.5l-7.2,1.1.5,3.4,13-2-1.8-12.9-3.4.5,1,7.1c-15.7-14-40.3-12.2-53.1,5.2-24.1,31.5,15.5,73,47.7,50.6-1.6,4.5-3.4,10.2-5.1,15.7-6.4,20.9-5.3,22.9-4.3,24.6,6,7.8,18.6,10.6,30.4,7.2l9.2,7.2c-2.3,11.6,7.1,12.4,32.2,13.8,23.3-1.2,44.4-15.5,51.6-31.4.9-3,1.2-9.1-5.2-26.6ZM88.8,152.8c13.7-7.5,18.2-16.2,18.3-17.1,2.4-1.2,4.5-3,6.1-5.1,11.1-1.4,23.4.2,29.1,11-8.7,7.2-21.4,7.9-35.8,8-3.4,2.4-7.7,5.5-11.2,8.3l-6.5-5.1ZM98.8,132.7c-17.2,0-17.2-26.2,0-26.3,17.2,0,17.2,26.2,0,26.3ZM166.6,143.3c-5.7,11.4-25.5,25.2-44.4,25.2-13.7-.4-20.2-2-22.9-3,1.7-1.5,6-4.7,9.9-7.5,18.6.1,30-2.8,44.6-13.7-2.4-3.5-2.8-5.1-6-9.5l-.7-15.8-6.9.3.4,8.1c-6.7-5.8-17.5-5.9-23.9-5.4,1.2-33.9-49.5-21.4-32.9,8-2.4,1.1-6.7,2.5-11,3.6l1.6,6.7c7.9-1.9,12.2-3.8,14.5-5.3,1.9,1.2,4.1,2.1,6.5,2.5-10.7,11.7-28.9,14.6-36.6,7.5,7.9-24.2,6.4-61,49.4-63,36.2-1.8,45.8,21.4,46.2,23.1,6.8,14.7,13.2,33.6,11.9,38.3Z"
            />
            <rect fill={color} x="27.6" y="65.1" width="9.8" height="29.4" />
            <rect fill={color} x="42.4" y="65.1" width="9.8" height="29.4" />
        </svg>
    );
};

export default FrozenIndex;
